module.exports = __webpack_public_path__ + "img/logo.ed2df9ea.png";